import React from 'react';
import styled from 'styled-components';
import { SkeletonLoader } from '../components/Loading/SkeletonLoader';

const FallbackContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 24px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
`;

const CardSkeleton = styled.div`
  padding: 20px;
  border-radius: 16px;
  background: ${({ theme }) => theme.card};
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

type Variant = 'cards' | 'faq' | 'banner';

interface SectionSkeletonFallbackProps {
  variant?: Variant;
}

export const SectionSkeletonFallback: React.FC<SectionSkeletonFallbackProps> = ({
  variant = 'cards',
}) => {
  if (variant === 'banner') {
    return (
      <FallbackContainer aria-hidden="true">
        <SkeletonLoader width="40%" height="32px" borderRadius="8px" />
        <SkeletonLoader width="70%" height="20px" borderRadius="8px" />
        <SkeletonLoader width="200px" height="44px" borderRadius="12px" />
      </FallbackContainer>
    );
  }

  if (variant === 'faq') {
    return (
      <FallbackContainer aria-hidden="true">
        <SkeletonLoader width="320px" height="36px" borderRadius="8px" />
        <SkeletonLoader width="480px" height="20px" borderRadius="8px" />
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonLoader key={i} width="100%" height="56px" borderRadius="12px" />
        ))}
      </FallbackContainer>
    );
  }

  return (
    <FallbackContainer aria-hidden="true">
      <SkeletonLoader width="280px" height="36px" borderRadius="8px" />
      <SkeletonLoader width="420px" height="20px" borderRadius="8px" />
      <CardGrid>
        {Array.from({ length: 3 }).map((_, i) => (
          <CardSkeleton key={i}>
            <SkeletonLoader width="100%" height="160px" borderRadius="12px" />
            <SkeletonLoader width="70%" height="22px" />
            <SkeletonLoader width="100%" height="14px" count={2} />
          </CardSkeleton>
        ))}
      </CardGrid>
    </FallbackContainer>
  );
};

export default SectionSkeletonFallback;
